module.exports = __webpack_public_path__ + "static/media/opelika.aa5e4524.png";